export default {
  title: "Cronologia",
  description: "Pianifica le tappe e gli eventi",
  addItem: "Aggiungi elemento",
  editItem: "Modifica elemento",
  deleteItem: "Elimina elemento",
  categories: {
    ceremony: "Cerimonia",
    reception: "Ricevimento",
    photos: "Foto",
    other: "Altro",
    photo: "Foto",
    preparation: "Preparazione",
    task: "Attività",
    vendor: "Fornitore",
    reminder: "Promemoria",
    custom: "Personalizzato",
    entertainment: "Intrattenimento",
    meal: "Pasto",
    transportation: "Trasporto",
    select: "Seleziona una categoria",
    religious_venue: "Luogo di culto",
    city_hall: "Municipio",
    none: "Nessuno"
  },
  examples: {
    preparation: {
      title: "Preparazione",
      description: "Preparazione degli sposi e vestizione"
    },
    ceremony: {
      title: "Cerimonia",
      description: "Cerimonia civile o religiosa"
    },
    cocktail: {
      title: "Cocktail",
      description: "Vino d'onore e foto"
    },
    lunch: {
      title: "Pranzo / Cena",
      description: "Pasto di nozze"
    },
    speeches: {
      title: "Discorsi",
      description: "Discorsi dei testimoni e della famiglia"
    },
    cakeCutting: {
      title: "Taglio della torta",
      description: "Tradizionale taglio della torta nuziale"
    },
    guestsArrival: {
      title: "Arrivo degli ospiti",
      description: "Gli ospiti iniziano ad arrivare alla location"
    },
    dancing: {
      title: "Ballo",
      description: "La pista da ballo è aperta"
    },
    cake: {
      title: "Torta",
      description: "Taglio della torta e champagne"
    },
    party: {
      title: "Festa",
      description: "Ballo di apertura e festa danzante"
    }
  },
  sharing: {
    recipientEmail: "Email del destinatario",
    emailPlaceholder: "esempio@email.com",
    recipientName: "Nome del destinatario",
    namePlaceholder: "Nome",
    message: "Messaggio",
    messagePlaceholder: "Il tuo messaggio...",
    send: "Invia",
    cancel: "Annulla",
    title: "Condividi cronologia"
  },
  addEvent: "Aggiungi evento",
  noEvents: "Nessun evento",
  addFirstEvent: "Aggiungi il tuo primo evento",
  titlePlaceholder: "Nome dell'evento",
  descriptionPlaceholder: "Descrizione dell'evento",
  durationLabel: "Durata",
  timelineWidget: {
    title: "Sequenza temporale",
    subtitle: "Prossimi eventi",
    empty: "Nessun evento in arrivo"
  },
  filters: {
    category: "Categoria",
    date: "Data",
    search: "Cerca un evento",
    clear: "Cancella filtri",
    apply: "Applica",
    previous: "Precedente",
    next: "Successivo"
  },
  status: {
    scheduled: "Pianificato",
    confirmed: "Confermato",
    completed: "Terminato",
    cancelled: "Annullato",
    delayed: "In ritardo",
    in_progress: "In corso"
  },
  participants: "Partecipanti",
  reminders: "Promemoria",
  minutesAbbr: "min",
  duration: "Durata",
  errors: {
    noWeddingFound: "Nessun matrimonio trovato",
    createWeddingFirst: "Crea prima un matrimonio",
    loadEvents: "Errore durante il caricamento degli eventi",
    addEvent: "Errore durante l'aggiunta dell'evento",
    updateEvent: "Errore durante l'aggiornamento dell'evento",
    deleteEvent: "Errore durante l'eliminazione dell'evento",
    addExampleEvents: "Errore durante l'aggiunta di eventi di esempio"
  },
  actions: {
    addEvent: "Aggiungi evento",
    share: "Condividi",
    useExample: "Usa un modello",
    addExamples: "Aggiungi esempi",
    addingExamples: "Aggiunta esempi in corso..."
  },
  empty: {
    title: "Nessun evento",
    description: "Inizia a pianificare la tua giornata aggiungendo eventi."
  },
  delete: {
    title: "Elimina evento",
    confirmation: "Sei sicuro di voler eliminare questo evento? Questa azione è irreversibile."
  },
  aria: {
    addEvent: "Aggiungi evento",
    edit: "Modifica evento",
    delete: "Elimina evento"
  },
  form: {
    title: "Dettagli dell'evento",
    name: "Cognome",
    description: "Descrizione",
    category: "Categoria",
    startTime: "Ora di inizio",
    endTime: "Ora di fine",
    location: "Luogo",
    notes: "Note",
    submit: "Salva",
    cancel: "Annulla"
  },
  messages: {
    createSuccess: "Evento aggiunto con successo",
    updateSuccess: "Evento aggiornato con successo",
    deleteSuccess: "Evento eliminato con successo",
    deleteConfirm: "Sei sicuro di voler eliminare questo evento?",
    error: "Si è verificato un errore"
  },
  modal: {
    title: "Evento",
    edit: "Modifica evento",
    delete: "Elimina evento",
    confirmDelete: "Sei sicuro di voler eliminare questo evento?"
  },
  view: {
    day: "Giorno",
    week: "Settimana",
    month: "Mese",
    today: "Oggi",
    daysLeft: "{{count}} giorni rimanenti",
    upcoming: "In arrivo"
  }
};
